
const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
};

export const replaceAll = (str: string, term: string, replacement: string) => {
  return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement)
}
